import { RouteInfo } from './sidebar.metadata';
import { environment } from 'environments/environment';

export const ROUTES: RouteInfo[] = [
  {
    path: environment.featureFlags.workplanTasks ? '' : '/plan-produccion',
    title: 'Plan de producción',
    icon: 'icon-social-dropbox',
    class: environment.featureFlags.workplanTasks ? 'has-sub' : '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: environment.featureFlags.workplanTasks ? [
      {
        path: '/plan-produccion/planes',
        title: 'Planes',
        icon: '',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      },
      {
        path: '/plan-produccion/tareas',
        title: 'Tareas',
        icon: '',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      }
    ] : []
  },
  {
    path: '',
    title: 'Catálogos',
    icon: 'ft-align-left',
    class: 'has-sub',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [
      {
        path: '/administradores',
        title: 'Administradores',
        icon: 'icon-users',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      },
      {
        path: '/clientes',
        title: 'Clientes',
        icon: 'icon-users',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      },
      {
        path: '/concesionarias',
        title: 'Concesionarias',
        icon: 'icon-home',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      },
      {
        path: '/ordenes-montaje',
        title: 'Órdenes de montaje',
        icon: 'icon-info',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      },
      {
        path: '/planos',
        title: 'Planos',
        icon: 'icon-map',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      },
      {
        path: '/flujos',
        title: 'Flujos',
        icon: 'icon-graph',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      },
      {
        path: '/maquinas',
        title: 'Máquinas',
        icon: 'icon-wrench',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      },
      {
        path: '/configuracion-maquina',
        title: 'Configuraciones',
        icon: 'icon-settings',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      },
      {
        path: '/sectores',
        title: 'Sectores',
        icon: 'ft-layout',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      },
      {
        path: '/tareas',
        title: 'Tareas',
        icon: 'icon-paper-clip',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      },
      {
        path: '',
        title: 'Incidencias',
        icon: 'icon-ban',
        class: 'has-sub',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [
          {
            path: '/incidencias',
            title: 'Listado',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: []
          },
          {
            path: '/grupo-de-falla',
            title: 'Grupo de falla',
            icon: '',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: []
          }
        ]
      },
      {
        path: '/usuarios',
        title: 'Usuarios',
        icon: 'ft-at-sign',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      },
      {
        path: '/vendedores',
        title: 'Vendedores',
        icon: 'icon-users',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      },
      {
        path: '/feriados',
        title: 'Días no laborables',
        icon: 'icon-calendar',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
      }
    ]
  }
];
